const constants = {
  API_URL: process.env.REACT_APP_API_URL,
  REQUIRE_INTERCEPTORS: {
    requestHandlerEnabled: true,
    responseHandlerEnabled: true
  },
  DEFAULT_COLUMNS: [
    'Work Order #',
    'Equipment ID',
    'Equipment Type',
    'Inspection Type',
    'Inspection Description',
    'Initial Inspection ',
    // 'Setback/Delay ',
    'NDE Required',
    'NDE Request Per Inspection Finding',
    'NDE Request Complete',
    'Eddy Current/ IRIS Examination',
    'UT Examination',
    'PT Examination',
    'MT Examination',
    'Advanced Non-Destructive Examination',
    // 'Repairs Needed/IWR Number',
    // 'Repairs Completed',
    'Final Inspection Review Complete',
    'Closure Form Signed',
    'Inspection Report Uploaded to Inspection Program',
    'General Comments',
  ],
  EXCEL_FILE_TYPES: [
    'application/vnd.ms-excel',
    'application/msexcel',
    'application/x-msexcel',
    'application/x-ms-excel',
    'application/x-excel',
    'application/x-dos_ms_excel',
    'application/xls',
    'application/x-xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],
  CELL_TYPES: {
    primary: 0,
    secondary: 1,
    tertiary: 2,
    custom: 3
  },
  TENARIS_EQUIPMENTS: [
    { label: 'COUPLING', value: 'COUPLING', multiplier: 10 },
    { label: 'FULL LENGTH', value: 'FULL LENGTH', multiplier: 10 },
    { label: 'MARKER JOINTS', value: 'MARKER JOINTS', multiplier: 10 },
    { label: 'PUP JOINTS', value: 'PUP JOINTS', multiplier: 10 },
    // { label: 'BARREL NIPPLE', value: 'BARREL NIPPLE', multiplier: 26.5 },
    { label: 'COLLAR', value: 'COLLAR', multiplier: 26.5 },
    { label: 'CROSS OVER', value: 'CROSS OVER', multiplier: 26.5 },
    // { label: 'EXTENSION NIPPLE', value: 'EXTENSION NIPPLE', multiplier: 26.5 },
    { label: 'FLOW COUPLING', value: 'FLOW COUPLING', multiplier: 26.5 },
    // { label: 'FLOAT COLLAR', value: 'FLOAT COLLAR', multiplier: 26.5 },
    { label: 'FLOAT SHOE', value: 'FLOAT SHOE', multiplier: 26.5 },
    // { label: 'GUIDE SHOE', value: 'GUIDE SHOE', multiplier: 26.5 },
    // { label: 'LANDING COLLAR', value: 'LANDING COLLAR', multiplier: 26.5 },
    { label: 'NIPPLE', value: 'NIPPLE', multiplier: 10 },
    { label: 'SLIDING SLEEVE', value: 'SLIDING SLEEVE', multiplier: 26.5 },
    // { label: 'SPACER NIPPLE', value: 'SPACER NIPPLE', multiplier: 26.5 },
    { label: 'SUBS', value: 'SUBS', multiplier: 26.5 },
    { label: 'BULL PLUG', value: 'BULL PLUG', multiplier: 54 },
    { label: 'CENTRALIZER', value: 'CENTRALIZER', multiplier: 26.5 },
    { label: 'END CAP', value: 'END CAP', multiplier: 54 },
    { label: 'EZ REAMER', value: 'EZ REAMER', multiplier: 54 },
    { label: 'HANDLING PLUG', value: 'HANDLING PLUG', multiplier: 54 },
    // { label: 'LIFT SUB', value: 'LIFT SUB', multiplier: 54 },
    { label: 'MANDREL', value: 'MANDREL', multiplier: 54 },
    { label: 'PACKER', value: 'PACKER', multiplier: 54 },
    { label: 'REDUCING ADAPTER', value: 'REDUCING ADAPTER', multiplier: 54 },
    { label: 'REAMER SHOE', value: 'REAMER SHOE', multiplier: 54 },
    { label: 'SETTING SLEEVES', value: 'SETTING SLEEVES', multiplier: 54 },
    { label: 'TEST PLUG', value: 'TEST PLUG', multiplier: 59.5 }, // 54
    // { label: 'BHANGER', value: 'BHANGER', multiplier: 59.5 },
    { label: 'HANGERS', value: 'HANGERS', multiplier: 59.5 },
    // { label: 'LINER HANGER', value: 'LINER HANGER', multiplier: 59.5 },
    { label: 'OFF CENTER ACC', value: 'OFF CENTER ACC', multiplier: 59.5 },
    { label: 'TEST CAP', value: 'TEST CAP', multiplier: 59.5 },
  ]
};

export default constants;